export const sentryBaseOption = {
  dsn: 'https://8800cb321d077d175ae0bccce629e6a2@o4507610489421824.ingest.us.sentry.io/4509834767237120',
  sendDefaultPii: false,
};

export const SENTRY_ENABLED_ENVS = ['staging', 'production', 'preview'];
